import React, { useState, useRef } from 'react';
import {
  MapContainer,
  TileLayer,
  FeatureGroup
} from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import axios from 'axios';

const NDVILiveMap = () => {
  const [lat, setLat] = useState('-23.346933');
  const [lon, setLon] = useState('-47.887825');
  const [areaDesenhada, setAreaDesenhada] = useState([]);
  const [resultado, setResultado] = useState(null);
  const mapRef = useRef();

  const handleCreated = (e) => {
    if (e.layerType === 'polygon') {
      const pts = e.layer.getLatLngs()[0].map(p => [p.lat, p.lng]);
      setAreaDesenhada(pts);
    }
  };

  const handleAnalyze = async () => {
    if (!lat || !lon || areaDesenhada.length < 3) {
      alert('Desenhe um polígono para analisar.');
      return;
    }

    const bounds = [
      [parseFloat(lat) - 0.004, parseFloat(lon) - 0.004],
      [parseFloat(lat) + 0.004, parseFloat(lon) + 0.004]
    ];

    try {
      const res = await axios.post('https://sense-agro-backend.onrender.com/api/analisar-perimetro', {
        coordenadas: areaDesenhada,
        bounds: bounds
      });

      setResultado(res.data);
    } catch (err) {
      console.error('Erro ao analisar perímetro:', err);
      alert('Erro ao enviar dados para análise.');
    }
  };

  const handleGerarPDF = async () => {
    try {
      const res = await fetch('https://sense-agro-backend.onrender.com/api/gerar-pdf', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...resultado,
          fazenda: 'Fazenda Modelo'
        })
      });

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'relatorio_ndvi.pdf';
      link.click();
    } catch (err) {
      alert('Erro ao gerar PDF');
      console.error(err);
    }
  };

  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h2 className="text-2xl font-bold mb-4 text-white">🛰️ Análise por Coordenada com QGIS</h2>

      <div className="flex gap-2 mb-4">
        <input
          value={lat}
          onChange={e => setLat(e.target.value)}
          type="number"
          placeholder="Latitude"
          className="p-2 rounded border w-full"
        />
        <input
          value={lon}
          onChange={e => setLon(e.target.value)}
          type="number"
          placeholder="Longitude"
          className="p-2 rounded border w-full"
        />
      </div>

      <MapContainer
        center={[parseFloat(lat), parseFloat(lon)]}
        zoom={17}
        scrollWheelZoom
        style={{ height: '450px', width: '100%', borderRadius: '12px', overflow: 'hidden' }}
        whenCreated={(map) => (mapRef.current = map)}
      >
        <TileLayer
          url={`https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoidGhpYWdvc2Vuc2VjbG91ZCIsImEiOiJjbTluOWNreTcwcDN3Mmpwemp5azgweDU5In0.-pJiJ3fHCcF9grajB-FC9g`}
          attribution="© Mapbox © OpenStreetMap"
          tileSize={512}
          zoomOffset={-1}
        />

        <FeatureGroup>
          <EditControl
            position="topright"
            onCreated={handleCreated}
            draw={{
              polygon: { allowIntersection: false, showArea: true, shapeOptions: { color: '#22c55e' } },
              rectangle: false,
              polyline: false,
              circle: false,
              marker: false,
              circlemarker: false,
            }}
            edit={{ remove: true }}
          />
        </FeatureGroup>
      </MapContainer>

      {areaDesenhada.length > 0 && (
        <div className="text-center mt-4">
          <button
            onClick={handleAnalyze}
            className="bg-green-800 text-white px-5 py-2 rounded-lg font-semibold hover:bg-green-600 flex gap-2 items-center justify-center"
          >
            <img src="/leonardo.png" alt="Leonardo" className="w-8 h-8" />
            Analisar com Leonardo
          </button>
        </div>
      )}

      {resultado && (
        <div className="mt-6 bg-white p-6 rounded shadow space-y-4 text-center">
          <h3 className="text-xl font-bold">📊 Resultado da Análise</h3>
          <p><strong>NDVI Médio:</strong> {resultado.ndvi_medio}</p>
          <p><strong>Classificação:</strong> {resultado.classificacao}</p>
          <p><strong>Alerta:</strong> {resultado.alerta}</p>
          <p><strong>Pixels Analisados:</strong> {resultado.quantidade_pixels}</p>
          <p><strong>Área Estimada:</strong> {resultado.hectares_estimados} hectares</p>

          {/* {resultado.ndvi_visual_url && (
            <div>
              <h4 className="text-lg font-semibold">NDVI visual</h4>
              <img
                src={`http://18.231.147.65:5000${resultado.ndvi_visual_url}`}
                alt="NDVI Visual"
                className="rounded border shadow mt-2 w-full max-w-xl mx-auto"
              />
            </div>
          )} }

          {resultado.heatmap_url && (
            <div>
              <h4 className="text-lg font-semibold mt-4">Mapa de Calor NDVI</h4>
              <img
                src={`http://18.231.147.65:5000${resultado.heatmap_url}`}
                alt="Mapa de Calor"
                className="rounded border shadow mt-2 w-full max-w-xl mx-auto"
              />
            </div>
          )}

          {/* {resultado.labels && (
            <div>
              <h4 className="text-lg font-semibold mt-4">🌈 Distribuição NDVI</h4>
              <div className="flex justify-center gap-4 mt-1">
                <span className="text-green-700">🟢 Verde: {resultado.labels.verde}%</span>
                <span className="text-yellow-600">🟡 Amarelo: {resultado.labels.amarelo}%</span>
                <span className="text-red-600">🔴 Vermelho: {resultado.labels.vermelho}%</span>
              </div>
            </div>
          )} */}

          <button
            onClick={handleGerarPDF}
            className="mt-6 bg-blue-700 hover:bg-blue-500 text-white font-semibold px-6 py-2 rounded shadow"
          >
            📄 Gerar PDF do Relatório
          </button>
        </div>
      )}
    </div>
  );
};

export default NDVILiveMap;
